/**
 * Product tabs behaviour.
 *
 * Progressive enhancement: the markup renders every panel open and readable
 * without this file. Adding data-enhanced hands visibility over to the tablist,
 * so a JS failure degrades to readable content rather than hidden content.
 *
 * Desktop: tabs, with the arrow-key behaviour the WAI-ARIA tabs pattern expects.
 * Under 750px: the same panels behave as an accordion, driven by the panel
 * headings, because a row of tabs would otherwise scroll sideways.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    root.setAttribute('data-enhanced', '');

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === index);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); select(next, true); }
      });
    });

    // Accordion on small screens. The first panel starts open so the section
    // never looks empty.
    panels.forEach(function (panel, i) {
      var title = panel.querySelector('.dtf-tabs__panel-title');
      if (!title) return;
      if (i === 0) panel.classList.add('is-open');
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');

      function toggle() {
        if (!window.matchMedia(MOBILE).matches) return;
        var open = panel.classList.toggle('is-open');
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    select(0);
  }

  function start() {
    document.querySelectorAll('[data-dtf-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme editor re-renders sections on edit
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dtf-tabs]');
    if (root) initTabs(root);
  });
})();
